// extracted by mini-css-extract-plugin
export default {"labelCheckbox":"KEfdlE7AQq5M0MdCo7jO"};